const normalize = value => String(value || '').normalize('NFKC').trim().toLocaleLowerCase();
// Search metadata never replaces the canonical label or immutable make ID.
export function makePickerOption(make, extra = {}) {
  return { value: Number(make.id), label: make.name, ...extra,
    searchText: [make.name, ...(Array.isArray(make.aliases) ? make.aliases.filter(alias => typeof alias === 'string') : [])].map(normalize).join('\n') };
}
export const filterMakeOption = (input, option) => normalize(option?.searchText || option?.label).includes(normalize(input));
